import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Auth is an httpOnly cookie set by the backend; the browser attaches it automatically.
export const api = axios.create({ baseURL: API, withCredentials: true });

export const uploadImage = async (file) => {
  const fd = new FormData();
  fd.append("file", file);
  const { data } = await api.post("/admin/upload", fd, { headers: { "Content-Type": "multipart/form-data" } });
  return data.image_id;
};

// Resolve an image reference (uploaded image_id or external image_url) to a src.
export const resolveImage = (item) => {
  if (!item) return "";
  if (item.image_id) return `${API}/media/${item.image_id}`;
  return item.image_url || "";
};

// Optimize third-party image URLs (Unsplash, Pexels) with WebP + width params.
// Own-storage images (/api/media/...) are served with long-cache and passed through.
const MEDIA_WIDTHS = [320, 480, 640, 800, 1024, 1280];

export const optimizeImage = (url, width = 1600) => {
  if (!url) return url;
  if (url.includes("/api/media/")) {
    const w = MEDIA_WIDTHS.find((mw) => mw >= width) || MEDIA_WIDTHS[MEDIA_WIDTHS.length - 1];
    return url.includes("?") ? url : `${url}?w=${w}`;
  }
  const [base, existingQuery] = url.split("?");
  if (base.includes("images.unsplash.com")) {
    return `${base}?auto=format&fit=crop&w=${width}&q=75`;
  }
  if (base.includes("images.pexels.com")) {
    return `${base}?auto=compress&cs=tinysrgb&fm=webp&w=${width}`;
  }
  return existingQuery ? url : url;
};

// Build a srcSet for a third-party image URL at multiple widths.
export const buildSrcSet = (url, widths = [640, 960, 1280, 1600, 1920]) => {
  if (!url) return undefined;
  if (url.includes("/api/media/")) return undefined;
  return widths.map((w) => `${optimizeImage(url, w)} ${w}w`).join(", ");
};

export const formatError = (detail) => {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
};
